import React from 'react'
import 'App.scss'
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline'
import { GlobalStateProvider } from 'state'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/ja'
import utc from 'dayjs/plugin/utc'
import dayjs from 'dayjs'
import { isMobileOnly } from 'react-device-detect'
import { DeskTop } from 'pages/DeskTop'
import { Login } from 'pages/Login'
import { Mobile } from 'pages/Mobile'
import * as cognito from 'common/cognito'
import { getAppTitle } from 'common/utils'
import { isPrivateMode, isYosokuMode } from 'common/config'

dayjs.extend(utc)

export const App = () => {
  const isLoginActive = isPrivateMode || isYosokuMode

  // redirect
  const location = useLocation()
  const navigate = useNavigate()

  React.useEffect(() => {
    document.title = getAppTitle()

    if (isLoginActive) {
      cognito.isAuthenticated()
        .then(auth => {
          console.log(auth.getIdToken().payload['cognito:username'])
        })
        .catch(() => {
          if (location.pathname !== '/login') {
            navigate('/login', {replace: true})
          }
        })
    }
  }, [])

  return (
    <div className='app'>
      <CssBaseline />
      <GlobalStateProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
          <Routes>
            <Route path="/login" element={ isLoginActive ? <Login /> : <Navigate to="/" replace /> } />
            <Route path="/" element={ isMobileOnly ? <Navigate to="/mobile" replace /> : <DeskTop /> } />
            <Route path="/mobile" element={ <Mobile /> } />
            <Route path="*" element={ <Navigate to="/" replace />} />
          </Routes>
        </LocalizationProvider>
      </GlobalStateProvider>
    </div>
  )
}
